import { left, right } from 'fp-ts/Either'

//
// Types & Interfaces
//

//
// Functions
//

export interface ConstantsResponse {
  mcp_sign_messages: {
    for_create_spirit: string
    for_update_spirit: string
  }
  mcp_auth_id: string
  total_spirits_count: number
  error?: string
  status: 'ok' | 'error'
}

export async function fetchConstants(prefix: string) {
  try {
    const response = await fetch(`${prefix}/`)
    const data: ConstantsResponse = await response.json()
    if (data.status === 'ok') {
      return right(data)
    }
    return left(data.error || 'Unknown error')
  } catch (err) {
    return left(err)
  }
}